import React, {useState, useEffect} from 'react';
import {useInterval} from '../student/utils';
import {Link} from 'react-router-dom';
import {Alert, Container, Row, Col, FormGroup, Label, Input, Button, Modal} from 'reactstrap';
import './GradingPage.css';
import ResponseImage from '../response/ResponseImage';
import ResponseText from '../response/ResponseText';
import Loading from '../components/waiting';
import _ from 'lodash';
import * as API from '../store/actions/fetchActions';
import {useDispatch, useSelector} from 'react-redux';

const Recategorize = props => {
    const {handle} = props;

    // Nothing is pre-selected so the reader must make a deliberate choice.
    const [mode, setMode] = React.useState(null); // 'blank' | 'recategorize'
    const [reason, setReason] = React.useState('');
    const radioClick = event => setMode(event.target.value);

    const canSubmit = mode === 'blank' || (mode === 'recategorize' && reason.trim().length > 0);

    const submit = () => {
        if (!canSubmit) return;
        if (mode === 'blank') {
            handle({recat: 'blank'});
        } else {
            handle({recat: 'recategorize', reason: reason.trim()});
        }
    };

    return (
        <Container className='recategorize'>
            <Row>
                <Col xs='12' className='recat-option'>
                    <Label check>
                        <Input
                            type='radio'
                            name='recat-mode'
                            value='blank'
                            checked={mode === 'blank'}
                            onChange={radioClick}
                        />{' '}
                        <strong>Score as Blank</strong>
                    </Label>
                </Col>

                <Col xs='12' className='recat-option'>
                    <Label check>
                        <Input
                            type='radio'
                            name='recat-mode'
                            value='recategorize'
                            checked={mode === 'recategorize'}
                            onChange={radioClick}
                        />{' '}
                        <strong>Recategorize because:</strong>
                    </Label>
                    <Input
                        type='textarea'
                        rows={2}
                        className='recat-reason'
                        placeholder='Enter reason here…'
                        value={reason}
                        disabled={mode !== 'recategorize'}
                        onChange={event => setReason(event.target.value)}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Button color='success' block onClick={submit} disabled={!canSubmit}>
                        Submit Blank or Recategorized Question
                    </Button>
                </Col>
            </Row>
        </Container>
    );
};

const Rubric = props => {
    const {rubric, scores, handle, onAllZero} = props;
    const allZero = rubric.length > 0 && rubric.every(r => String(scores[r.part]) === '0');
    return (
        <Container className='scoringRubric'>
            <Row>
                <h6>SCORING RUBRIC</h6>
                <Col xs='12' className='all-parts-zero'>
                    <FormGroup check>
                        <Label check>
                            <Input type='checkbox' checked={allZero} onChange={onAllZero} />{' '}
                            <strong>All Parts Earned &ldquo;0&rdquo;</strong>
                        </Label>
                    </FormGroup>
                </Col>
                {rubric.map((r, idx) => (
                    <Col xs='12' key={idx}>
                        <FormGroup tag='fieldset' name={r.part}>
                            <strong>{r.part}</strong>
                            <br />
                            {[...Array(r.range + 1)].map((e, i) => (
                                <FormGroup check key={i}>
                                    {' '}
                                    &nbsp; &nbsp; &nbsp;
                                    <Label check>
                                        <Input
                                            type='radio'
                                            name={r.part}
                                            value={i}
                                            checked={String(scores[r.part]) === String(i)}
                                            onChange={handle}
                                        />{' '}
                                        {i}
                                    </Label>
                                </FormGroup>
                            ))}
                        </FormGroup>
                        <br />
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

const Comments = props => {
    const {comments, handle} = props;
    const [checkmarks, setCheckmarks] = React.useState({});
    const handleCheck = event => {
        const {name, value, checked} = event.target;
        let newvalue = checkmarks[name];
        if (checked && !newvalue) {
            newvalue = [value];
        } else if (checked) {
            newvalue.push(value);
        } else if (newvalue) {
            newvalue = newvalue.filter(v => v !== value);
        }
        const newchecks = {
            ...checkmarks,
            [name]: newvalue,
        };
        setCheckmarks(newchecks);
        handle({
            target: {
                name: name,
                value: newvalue.join('\n'),
            },
        });
    };
    return (
        <Col xs='12'>
            <div className='scoringComments container'>
                <h6>SCORING COMMENTS</h6>
                {comments.map((c, idx) => (
                    <Col xs='12' key={idx}>
                        <FormGroup check name={c.part}>
                            <legend>
                                <small>{c.part}</small>
                            </legend>
                            <ul>
                                {c.comments.map((cmt, idx) => (
                                    <li key={idx}>
                                        <Label check key={idx}>
                                            <Input
                                                type='checkbox'
                                                name={c.part}
                                                value={cmt.text}
                                                onChange={handleCheck}
                                            />
                                            {cmt.text}
                                        </Label>
                                    </li>
                                ))}
                            </ul>
                        </FormGroup>
                    </Col>
                ))}
                <FormGroup>
                    <Label for='txtComments'>Other Comments:</Label>
                    <Input
                        type='textarea'
                        name='txtComments'
                        id='txtComments'
                        rows={5}
                        onChange={handle}
                    />
                </FormGroup>
            </div>
        </Col>
    );
};

const TimeoutModal = props => {
    const {isOpen, loading, handle} = props;
    return (
        <Modal isOpen={isOpen}>
            <Container>
                <h3>Do you need more time?</h3>
                {loading ? (
                    <Loading />
                ) : (
                    <Button color='primary' block onClick={handle}>
                        Reset Timeout
                    </Button>
                )}
            </Container>
        </Modal>
    );
};

const Page = props => {
    const [showTimeoutModal, setShowTimeoutModal] = useState(false);
    const [activityTimer, setActivityTimer] = useState(null);
    const [cancelTimer, setCancelTimer] = useState(null);
    const [scores, setScores] = useState({});
    const [mapScores, setMapScores] = useState([]);
    const [filled, setFilled] = useState(false);
    const [comments, setComments] = useState({txtComments: null});
    const [mapComments, setMapComments] = useState([]);
    const dispatch = useDispatch();
    const refreshing = useSelector(state => state.reader.refreshingCheckout);

    const {questionId, responseId} = props;

    useEffect(() => {
        setActivityTimer(refreshing ? null : 1500000);
    }, [refreshing]);

    useInterval(
        () => {
            setActivityTimer(null);
            setCancelTimer(300000);
            setShowTimeoutModal(true);
        },
        activityTimer,
        true
    );

    const doCancel = () => {
        setActivityTimer(null);
        setCancelTimer(null);
        setShowTimeoutModal(false);
        props.onCancel(questionId, responseId);
    };

    useInterval(doCancel, cancelTimer, true);

    const checkFilled = (scoreValues, commentValues) => {
        const si = _.range(props.rubric.length);
        const scoresFilled = si.reduce((acc, i) => acc && scoreValues[i] !== undefined, true);
        if (props.presetCommentsRequired) {
            const ci = props.comments.reduce(
                (acc, part) => (part.comments.length > 0 ? [...acc, part.part] : acc),
                []
            );
            const commentsFilled = ci.reduce((acc, i) => acc && !!commentValues[i], true);
            setFilled(scoresFilled && commentsFilled);
        } else {
            setFilled(scoresFilled);
        }
    };

    const handleScore = event => {
        const newScores = {
            ...scores,
            [event.target.name]: event.target.value,
        };
        setScores(newScores);
        const newMap = props.rubric.map(r => newScores[r.part]);
        setMapScores(newMap);
        checkFilled(newMap, comments);
    };

    // "All Parts Earned 0" shortcut: fill every rubric part with 0 (or clear when unchecked)
    const handleAllZero = event => {
        const setZero = event.target.checked;
        const newScores = {};
        if (setZero) {
            props.rubric.forEach(r => {
                newScores[r.part] = '0';
            });
        }
        setScores(newScores);
        const newMap = props.rubric.map(r => newScores[r.part]);
        setMapScores(newMap);
        checkFilled(newMap, comments);
    };

    const handleComment = event => {
        const newComments = {
            ...comments,
            [event.target.name]: event.target.value,
        };
        setComments(newComments);
        setMapComments(props.rubric.map(r => newComments[r.part]));
        // what if event.target.name is not one of props.rubric.part ??
        checkFilled(mapScores, newComments);
    };

    const doExtend = () => {
        setCancelTimer(null);
        setShowTimeoutModal(false);
        dispatch(API.refreshReaderLock(questionId, responseId));
    };

    const doRecategorize = data => {
        setActivityTimer(null);
        setCancelTimer(null);
        dispatch(API.putRecategorize(questionId, responseId, data));
    };

    const doSubmit = event => {
        // read the value before any async work — React pools synthetic events
        const keepGoing = event.target.value === 'next';
        setActivityTimer(null);
        setCancelTimer(null);
        Promise.resolve(
            dispatch(
                API.postResponseScore(questionId, {
                    keepGoing,
                    responseId: responseId,
                    scores: mapScores.map((e, i) => ({
                        part: props.questionNumber + '.' + props.rubric[i].part,
                        score: e,
                        comment: mapComments[i],
                    })),
                    otherComment: comments.txtComments,
                })
            )
        ).then(saved => {
            // "Submit - I'm finished scoring" should return the reader to the question list
            // instead of leaving the scored response on screen.
            if (saved && !keepGoing && props.onFinished) {
                props.onFinished();
            }
        });
    };

    return (
        <React.Fragment>
            <TimeoutModal isOpen={showTimeoutModal} handle={doExtend} loading={refreshing} />
            {props.testResponse && (
                <Row>
                    <Col xs='12'>
                        <Alert color='danger'>
                            This is a test response to help you calibrate your scoring.
                        </Alert>
                    </Col>
                </Row>
            )}
            <Row>
                <Col sm='8'>
                    <h2>Response - {props.responseId}</h2>
                    <h2>Exam - {props.examCode}</h2>
                    <h2>Teacher - {props.teacherId}</h2>
                    <h2>Student - {props.studentId}</h2>
                </Col>
                {/* <Col sm='8'>
                    <h2>Response - {props.responseId}</h2>
                </Col> */}
                <Col sm='8'>
                    {props.children}
                    <ResponseText html={props.html} />
                    {props.images.map((img, idx) => (
                        <ResponseImage key={idx} url={img} />
                    ))}
                </Col>
                <Col sm='4'>
                    {!props.testResponse && (
                        <Recategorize
                            questionNumber={props.questionNumber}
                            questionDdl={props.questionDdl}
                            handle={doRecategorize}
                        />
                    )}
                    <Rubric
                        rubric={props.rubric}
                        scores={scores}
                        handle={handleScore}
                        onAllZero={handleAllZero}
                    />
                </Col>
                <Comments comments={props.comments} handle={handleComment} />
            </Row>
            {}
            <Row>
                {!props.testResponse && (
                    <Col>
                        <Button
                            color='primary'
                            block
                            value='finish'
                            onClick={doSubmit}
                            disabled={!filled}
                        >
                            Submit - I'm finished scoring
                        </Button>
                    </Col>
                )}
                <Col>
                    <Button color='primary' block value='cancel' onClick={doCancel}>
                        Cancel
                    </Button>
                </Col>
                {!props.testResponse && (
                    <Col>
                        <Button
                            color='primary'
                            block
                            value='next'
                            onClick={doSubmit}
                            disabled={!filled}
                        >
                            Submit - Score another essay
                        </Button>
                    </Col>
                )}
                {props.testResponse && (
                    <Col>
                        <Link to={'/reader'}>
                            <Button
                                color='primary'
                                block
                                value='next'
                                onClick={doSubmit}
                                disabled={!filled}
                            >
                                Submit - Back to reader home
                            </Button>
                        </Link>
                    </Col>
                )}
            </Row>
        </React.Fragment>
    );
};

export default Page;
